import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService, TreeNode } from 'primeng/api';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
import { ShipmentASN } from '../../../../service/shipment-asn.service';

export interface SelectedRow {
  item_no: string;
  plant: string;
  poagreement_no: string;
  poagreementNo: string;
  quantity: string;
  pono: string;
  qty: number;
  plant_code: string
  schedule_batch: ScheduleBatch[];
  editing?: boolean;
  plant1:string;
  // quantity:number
}
export interface ScheduleBatch {
  actualQTY: number;
  BatchNo: string;
  serialNO: string;
}

interface Column {
  field: string;
  filterMatchMode: string;
}

@Component({
  selector: 'app-process-shimpent-asn',
  templateUrl: './process-shimpent-asn.component.html',
  styleUrl: './process-shimpent-asn.component.scss'
})
export class ProcessShimpentAsnComponent implements OnInit {

  scheduleBatchForm!: FormGroup

  itemBatchNumbers: { [key: string]: string[] } = {};

  selectedRows: SelectedRow[] = [];
  mappedData: TreeNode<any>[] = [];
  scheduleBatch: ScheduleBatch[] = []
  cols!: Column[];
  files!: TreeNode[];
  existingBatchNos: string[] = [];
  selectedRow: SelectedRow | null = null;

  isAddBatch:boolean=true
  isAddBtnDisable:boolean=true
  isQtyEmpty:boolean=false


  selectedRowIndex: number | null = null;

  visible: boolean = false;
  quantityExceedsMax = false;


  selectedPerentKey: any;
  selectedChildKey: any;
  scheduleBatchValues: any;

  displayedData: ScheduleBatch[] = [];
  availableQuantity: number = 0
  totalQuantity: number = 0
  currentQuantity: number = 0
  remainingQuantityForDelete: number = 0

  itemQuantity: any
  useditemQuantity: any
  remainingQuantity: any

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private messageService: MessageService,
    private shipmentsASNList: VendorTsService,
    private shipmentASN: ShipmentASN,
    private confirmationService: ConfirmationService
  ) {
  }

  ngOnInit(): void {
    this.loadExistingBatchNos();

    this.scheduleBatchForm = this.fb.group({
      actualQTY: [null, Validators.required],
      BatchNo: [null, [Validators.required, this.validateUniqueBatchNo()]],
      serialNO: [null],
    });
    const selectedRows = history.state.selectedRows;
    if (!selectedRows || !Array.isArray(selectedRows)) {
      console.log('No valid selected rows found.');
      return;
    }

    this.selectedRows = selectedRows.map(row => ({ ...row, schedule_batch: row.schedule_batch || [], pono: row.pono || '' }));
    if (this.selectedRows) {
      this.oldQty = this.selectedRows[0].quantity
    }


    this.initializeColumns();
    this.displayData();
  }

  loadExistingBatchNos(): void {
    this.shipmentsASNList.getExistingBatchNos().then((response: any) => {
      this.existingBatchNos = response.message;
    }).catch(error => {
      console.error('Failed to load existing batch numbers', error);
    });

  }


  validateUniqueBatchNo = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
      const batchNo = control.value;

      const existsInDatabase = this.existingBatchNos.includes(batchNo);
      if (existsInDatabase) {
        return { existingBatchNo: true };
      }

      for (const itemBatches of Object.values(this.itemBatchNumbers)) {
        if (itemBatches.includes(batchNo)) {
          return { duplicateBatchNo: true };
        }
      }

      if (this.selectedRowIndex !== null) {
        const currentBatches = this.selectedRows[this.selectedRowIndex]?.schedule_batch || [];
        const isDuplicate = currentBatches.some((batch: ScheduleBatch) => batch.BatchNo === batchNo);
        return isDuplicate ? { duplicateBatchNo: true } : null;
      }

      return null;
    };
  };



  initializeColumns() {
    this.cols = [
      { field: 'itemNo', filterMatchMode: 'contains' },
      { field: 'plant', filterMatchMode: 'contains' },
      { field: 'pono', filterMatchMode: 'contains' },
      { field: 'qty', filterMatchMode: 'contains' },
    ];
  }

  displayData() {
    this.mappedData = this.selectedRows.map((item, index) => {
      return {
        key: `parent_${index}`,
        data: {
          itemNo: item.item_no,
          plant: item.plant,
          pono: item.poagreement_no,
          qty: item.quantity,
        },
        children: item.schedule_batch?.map((child, childIndex) => ({
          key: `child_${index}_${childIndex}`,
          data: {
            itemNo: '',
            plant: child.actualQTY,
            pono: child.BatchNo,
            qty: child.serialNO,
          }
        }))
      };
    });
    this.files = this.mappedData ? [...this.mappedData] : [];
    this.applyExpandedStates(this.files || []);
  }

  applyExpandedStates(nodes: TreeNode<any>[]) {
    for (const node of nodes) {
      if (node.key !== undefined && node.key === this.selectedPerentKey) {
        node.expanded = true;
      }
    }
  }

  showDialog(data: any): void {
    this.displayedData = []
    this.currentQuantity = 0
    this.availableQuantity = 0
    this.totalQuantity = 0

    this.selectedRow = data.node.data
    let scheduleBatchVal = data.node.children;

    scheduleBatchVal.forEach((e: any) => {
      let scheduleBatch: ScheduleBatch = {
        BatchNo: '',
        actualQTY: 0,
        serialNO: ''
      };
      scheduleBatch.BatchNo = e.data.pono
      scheduleBatch.actualQTY = e.data.plant
      scheduleBatch.serialNO = e.data.qty
      this.displayedData.push(scheduleBatch)
    });

    this.availableQuantity = this.selectedRow!.qty
    for (const schedule of scheduleBatchVal) {
      this.totalQuantity += schedule.data.plant
    }

    this.currentQuantity = this.availableQuantity - this.totalQuantity

    this.scheduleBatchForm.get('actualQTY')?.setValue(this.currentQuantity)

    if (this.currentQuantity === 0) {
      this.isQtyEmpty=true
      this.isAddBatch=false
    }else{
      this.isQtyEmpty=false
      this.isAddBatch=true
      this.isAddBtnDisable=true
    }

    this.visible = true;
    this.quantityExceedsMax = false;

  }
  onClose() {
    this.visible = false
  }

  deleteSchedule(schedule: ScheduleBatch) {

    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {

            this.mappedData.forEach((mdata) => {
              if (mdata.children) {
                  for (let i = mdata.children.length - 1; i >= 0; i--) {
                      if (mdata.children[i].data.pono === schedule.BatchNo) {
                          mdata.children.splice(i, 1);
                      }
                  }
              }
          });

          this.selectedRows.forEach((row) => {
            if (row.schedule_batch) {
                for (let i = row.schedule_batch.length - 1; i >= 0; i--) {
                    if (row.schedule_batch[i].BatchNo === schedule.BatchNo) {
                      row.schedule_batch.splice(i, 1);
                    }
                }
            }
        });

            const filterSchedule = this.displayedData.filter((val) => val.BatchNo === schedule.BatchNo);
            if (filterSchedule.length === 1) {
              const index = this.displayedData.indexOf(filterSchedule[0]);
              if (index !== -1) {
                  // Remove the item from displayedData using splice
                  this.displayedData.splice(index, 1);
              }
          }
          this.mappedData = [...this.mappedData];
          let availableActualQTY :number
          availableActualQTY=this.remainingQuantityForDelete + schedule.actualQTY
          this.scheduleBatchForm.get('actualQTY')?.setValue(availableActualQTY)

          if (this.isAddBatch) {
            this.isAddBtnDisable=true
          }else{
            this.isAddBtnDisable=false
          }
          this.isQtyEmpty=false
          this.quantityExceedsMax = false;
          this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Schedule Batch Deleted', life: 3000 });
        }
    });
}

  validateQuantity(event: any): void {
    const enteredQuantity = this.scheduleBatchForm.get('actualQTY')?.value;
    const plannedQuantity = this.mappedData[this.selectedRowIndex!].data.qty;

    let totalActualQuantity = enteredQuantity ? enteredQuantity : 0;

    const selectedRow = this.selectedRows[this.selectedRowIndex!];
    if (selectedRow.schedule_batch) {
      for (const batch of selectedRow.schedule_batch) {
        totalActualQuantity += batch.actualQTY;
      }
    }
    if (enteredQuantity === 0) {
      this.quantityExceedsMax = true;
    } else if (totalActualQuantity > plannedQuantity) {
      this.quantityExceedsMax = true;
    } else {
      this.quantityExceedsMax = false;
    }

  }

  setSelectedRowIndex(rowData: any) {
    const index = this.mappedData.findIndex(item => item.data === rowData);
    this.selectedRowIndex = index !== -1 ? index : null;
  }

  onClickAdd(){
    this.isAddBatch=true
    this.isAddBtnDisable=true
  }
  createScheduleBatch() {
    const { selectedRowIndex, mappedData, selectedRows, scheduleBatchForm } = this;
    if (selectedRowIndex !== null && selectedRowIndex >= 0 && selectedRowIndex < mappedData.length) {

      const selectedRow = selectedRows[selectedRowIndex];
      const itemNo = selectedRow.item_no;
      const batchNo = scheduleBatchForm.value.BatchNo;
      if (!this.itemBatchNumbers[itemNo]) {
        this.itemBatchNumbers[itemNo] = [];
      }
      this.itemBatchNumbers[itemNo].push(batchNo);

      const parentIndex = selectedRowIndex;
      this.selectedPerentKey = 'parent_' + selectedRowIndex
      const newScheduleBatch: ScheduleBatch = {
        actualQTY: scheduleBatchForm.value.actualQTY,
        BatchNo: scheduleBatchForm.value.BatchNo,
        serialNO: scheduleBatchForm.value.serialNO
      };

      if (parentIndex >= 0 && parentIndex < selectedRows.length) {

        selectedRows[parentIndex].schedule_batch = selectedRows[parentIndex].schedule_batch || [];
        selectedRows[parentIndex].schedule_batch.push(newScheduleBatch);
        // selectedRows[parentIndex].vcode
        this.displayData();



        this.displayedData = []
        this.currentQuantity = 0
        this.totalQuantity = 0
        this.availableQuantity = 0;
        this.remainingQuantityForDelete=0
        let scheduleBatchVal = selectedRows[parentIndex].schedule_batch
        scheduleBatchVal.forEach((e: any) => {
          this.displayedData.push(e)
        });

        this.availableQuantity = Number(selectedRows[parentIndex].quantity)
        for (const schedule of scheduleBatchVal) {
          this.totalQuantity += Number(schedule.actualQTY)
        }

        this.currentQuantity = this.availableQuantity - this.totalQuantity

        this.scheduleBatchForm.reset()

        this.scheduleBatchForm.get('actualQTY')?.setValue(this.currentQuantity)
        this.remainingQuantityForDelete= this.currentQuantity
        this.isAddBatch=false
        this.isAddBtnDisable=false
        if (this.currentQuantity === 0) {
          this.isAddBtnDisable=true
          this.isQtyEmpty=true
        }
      } else {
        console.error('Invalid parentIndex:', parentIndex);
      }
    } else {
      console.error('Invalid selected row index:', selectedRowIndex);
    }
  }

  setButton(rowData: any): boolean {
    if (rowData.node.key.startsWith('parent')) {
      return true
    }
    else {
      return false
    }
  }

  createShipmentASN(): void {
    const allRowsHaveScheduleBatch = this.selectedRows.every(row => row.schedule_batch.length > 0);

    if (!allRowsHaveScheduleBatch) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please add atleast one batch pr item" });
      return;
    }

    const navigationExtras: NavigationExtras = {
      state: {
        selectedRows: this.selectedRows
      }
    };
    this.router.navigate(['/create-shipment-asn'], navigationExtras);
  }

  onRowEdit(selectedRow: any) {
    this.shipmentASN.getSFSList().then((res) => {
      const filteredRes = res.filter((item: any) => item.item_no === selectedRow.itemNo);
      return filteredRes[0];
    }).then((filteredRes: any) => {
      filteredRes.quantity = selectedRow.qty;
      return this.shipmentASN.get_selected_item_detail(filteredRes);
    }).then((res) => {
      this.scheduleBatchForm.get('actualQTY')?.setValue(res.message.data.quantity);
      this.itemQuantity = res.message.data.new_item_data.item[0].quantity;
      this.useditemQuantity = res.message.data.new_item_data.shipments.reduce((total: number, element: any) => {
        return total + element.delivery_schedule.quantity;
      }, 0);
      this.remainingQuantity = this.itemQuantity - this.useditemQuantity;
      this.remainingQuantity = this.remainingQuantity + selectedRow.qty
      this.displayData();
    }).catch((error: any) => {
      console.error(error);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill correct detail' });
    });
  }

  oldQty: any

  validatePlannedQuantity(selectedRow: any, rowIndex: number): void {
    this.quantityExceedsMax = true;
    if (selectedRow.qty) {
      if (selectedRow.qty <= this.remainingQuantity) {
        this.scheduleBatchForm.get('actualQTY')?.setValue(selectedRow.qty)
        this.quantityExceedsMax = false;
      }
    }
  }

  onRowEditSave(selectedRow: any) {
    const { selectedRowIndex} = this;
    let parentIndex: number;

    if (selectedRowIndex !== null && selectedRowIndex !== undefined) {
      parentIndex = selectedRowIndex;
    }
    if (selectedRow.qty <= this.remainingQuantity) {
      return new Promise((resolve, reject) => {
        this.shipmentASN.getSFSList().then((res) => {
          const filteredRes = res.filter((item: any) => item.item_no === selectedRow.itemNo);
          resolve(filteredRes);
        }).catch((error: any) => {
          reject(error);
        });
      }).then((filteredRes: any) => {
        filteredRes[0].quantity = selectedRow.qty;
        return this.shipmentASN.update_planned_quantity(filteredRes[0]);
      }).then((res) => {
        this.remainingQuantity - selectedRow.qty
        this.selectedRows[parentIndex].quantity = selectedRow.qty
        this.oldQty = selectedRow.qty
        this.availableQuantity = selectedRow.qty
        this.displayData();
        this.scheduleBatchForm.get('actualQTY')?.setValue(this.oldQty);
        const message = res.message;
        const severity = message.status === "Success" ? "success" : "error";
        this.messageService.add({ severity, summary: severity === "success" ? 'Success' : 'Error', detail: message.message });
      }).catch((error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all required detail' });
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Planned quantity cannot exceed total quantity' });
      return Promise.resolve();
    }
  }

  onCancleEdit(selectedRow: any) {
    selectedRow.qty = this.oldQty
    this.scheduleBatchForm.get('actualQTY')?.setValue(selectedRow.qty);
  }



}
